const ClassAssistant = (r) =>
  require.ensure(
    [],
    () => r(require('../views/qyweixin/ClassAssistant.vue')),
    'ClassAssistant'
  )
const classNotice = (r) =>
  require.ensure(
    [],
    () => r(require('../views/qyweixin/classNotice.vue')),
    'classNotice'
  )

export default [
  {
    name: 'ClassAssistant',
    path: '/ClassAssistant',
    component: ClassAssistant,
    meta: { title: '班级助手' },
  },
  {
    name: 'classNotice',
    path: '/classNotice',
    component: classNotice,
    meta: { title: '课程提醒' },
  },
]
